/* foyrCaptureBookmarklet — the one-liner the designer installs in
 * Foyr Neo's editor to capture the real project bundle.
 *
 * What it does (every step verified live 2026-05-17):
 *   1. Patch `Object.prototype.toJSON` with a safe-default fallback
 *      (Foyr's exporter calls `.toJSON()` on a class without one).
 *   2. Hook `JSON.stringify` to intercept the bundle when the
 *      exporter builds it (50KB+ string starting with `{"assetGroupList`).
 *   3. Call `window.neoEditor.projectExporter.export()` to trigger
 *      the build path.
 *   4. Copy the captured bundle to the clipboard.
 *   5. Restore the original `JSON.stringify` + drop the polyfill.
 *
 * Designed to fit on a single bookmark — minified, no external
 * dependencies, no permissions beyond what the user's tab already
 * has. The user's own session + the function their own editor
 * already exposes; we read what their screen would render. */

export function buildFoyrCaptureBookmarklet(): string {
  // The body is kept readable here; we minify at export time below.
  const src = `(function(){
  var bundle=null;
  var origStringify=JSON.stringify;
  JSON.stringify=function(){
    var r=origStringify.apply(this,arguments);
    if(typeof r==='string' && r.length>50000 && r.indexOf('assetGroupList')>=0) bundle=r;
    return r;
  };
  var installedPoly=!Object.prototype.toJSON;
  if(installedPoly){
    Object.defineProperty(Object.prototype,'toJSON',{
      value:function(){
        try{
          var o={};
          for(var k in this){
            if(this.hasOwnProperty(k) && typeof this[k]!=='function') o[k]=this[k];
          }
          return o;
        }catch(e){return null;}
      },
      writable:true,configurable:true
    });
  }
  try{
    var e=window.neoEditor;
    if(!e||!e.projectExporter){
      alert('FoyrMind capture · open a Foyr Neo editor tab first.');
      return;
    }
    if(typeof e.projectExporter.init==='function') e.projectExporter.init();
    e.projectExporter.export();
  }catch(err){console.warn('FoyrMind capture · export threw',err);}
  finally{
    if(installedPoly) delete Object.prototype.toJSON;
    JSON.stringify=origStringify;
  }
  if(!bundle){
    alert('FoyrMind capture · no bundle captured. Make sure a project is loaded.');
    return;
  }
  navigator.clipboard.writeText(bundle).then(function(){
    alert('FoyrMind capture · '+(bundle.length/1024).toFixed(1)+' KB copied. Paste into the Onboard Foyr card.');
  },function(){
    var w=window.open('','_blank');
    if(w){w.document.body.style.fontFamily='monospace';w.document.body.textContent=bundle;}
    else alert('FoyrMind capture · clipboard blocked, opened a new tab with the bundle.');
  });
})();`;
  // Compact for use as a javascript: URL.
  const minified = src.replace(/\s+/g, " ").replace(/\s*([=;{}(),])\s*/g, "$1").trim();
  return "javascript:" + encodeURIComponent(minified);
}
